var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#4C5A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 6.33544L15.1627 5.93775L15.0401 6.27131L14.3505 6.85069L13.5608 6.96825L13.3245 6.74944L14.0169 5.83088L14.7257 5.625L13.9584 5.64075L12.843 6.41812L11.7973 6.34612L10.3292 5.625L9.46181 5.79319L6.75563 7.95656L5.45175 8.35988L4.91512 8.88356L3.9555 8.8965L3.48019 9.74588L2.8125 9.93037L3.44363 10.0131L4.03031 9.252L4.93706 9.43369L4.92019 10.2482L4.46737 11.4204L4.20862 12.5049L3.93019 12.9375L4.63669 12.7879L4.55625 12.3446L5.157 11.1532L6.3135 10.7049L6.76125 9.99169L7.51781 9.46294L9.01969 9.67387L10.5323 9.03544L10.2763 10.0451L9.60356 10.1036L9.41175 10.9316L9.98719 10.5632L10.9412 10.1655L11.6865 9.04106L11.7338 8.5095L12.1343 8.90719L13.2992 9.60975L13.9613 9.30769L13.9224 7.82325L13.7301 7.24894L14.5952 7.038L15.1875 6.33544Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoly);
export default __webpack_public_path__ + "static/media/poly.80ddc9ae297362bb974eb3bf8b80cbb2.svg";
export { ForwardRef as ReactComponent };